import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

const trackSectionHeaderClick = (
  sectionName: string,
  isPersonalView: boolean,
  source: SCREEN_NAME = SCREEN_NAME.PROFILE,
) => {
  sendUIEvent({
    source,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'sectionHeader',
    attributes: {
      sectionName,
    },
    isPersonalView,
  });
};

export { trackSectionHeaderClick };
